import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// third-party modules
import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';

// bayclubs modules
import { DropDownModule } from '@bayclubs/drop-down';

// app modules
import { SharedModule } from '@shared/shared.module';

// state
import { NavigationState } from './store/navigation.state';

// containers
import { BayclubsUiCoreModule } from '@bayclubs/ui-core';
import { ContextComponent } from './containers/context/context.component';
import { DefaultRouteComponent } from './containers/default-route/default-route.component';

@NgModule({
    declarations: [ContextComponent, DefaultRouteComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([NavigationState]),
        NgxsFormPluginModule,
        TranslateModule.forChild(),
        SharedModule,
        DropDownModule,
        BayclubsUiCoreModule
    ]
})
export class NavigationModule { }

export * from './store/navigation.facade';

export { ContextComponent } from './containers/context/context.component';
export { DefaultRouteComponent } from './containers/default-route/default-route.component';
